import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, input, model, signal } from '@angular/core';
import { ListQuest } from '../../services/lists/list-quest';
import { ListRoles } from '../../services/lists/list-roles';

@Component({
  selector: 'app-dropdown-component',
  imports: [CommonModule],
  templateUrl: './dropdown-component.html',
  styleUrl: './dropdown-component.scss'
})
export class DropdownComponent {
  // Array of options for the dropdown
  items = ['Profile', 'Settings', 'Billing', 'Logout'];
  
  // Track selected item and visibility state using Signals
  selectedItem = signal<string>('Select an Option');
  isOpen = model<boolean>(false);
  rqId = input<number>();

  quests = inject(ListQuest);
  roles = inject(ListRoles);

  constructor(private elementRef: ElementRef) {}

  // toggleDropdown() {
  //   this.isOpen.update(value => !value);
  // }

  selectItem(item: string) {
    this.selectedItem.set(item);
    this.isOpen.set(false); // Close menu on selection
  }

  getQuestName(): string{
    let result;
    if(this.rqId() as number > 100){
        result = (this.quests.quests)?this.quests.findQuest(this.rqId() as number):null;
      }else{
        result = (this.roles.roles)?this.roles.findRole(this.rqId() as number):null;
      }
   
    return (result?.data?.humman_description?.title)?result?.data?.humman_description.title : '';
  }

  getQuestIcons(){
    let result;    
    if(this.rqId() as number > 100){
      result = (this.quests.quests)?this.quests.findQuest(this.rqId() as number):null;
    }else{
      result = (this.roles.roles)?this.roles.findRole(this.rqId() as number):null;
    }
    let listIcons = result?.icons.map((element: any) => `<span class="material-symbols-outlined color_${this.rqId() as number}">${element}</span>`);
    return listIcons.join('');
  }

  // Closes the dropdown if clicked outside the host element
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
